import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface AppState {
  isDraftPreviewOpen: boolean;
  isSiteSameAsGeneratedInPreauth: boolean;
}

const initialState: AppState = {
  isDraftPreviewOpen: false,
  isSiteSameAsGeneratedInPreauth: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openDraftPreview(state) {
      state.isDraftPreviewOpen = true;
    },
    closeDraftPreview(state) {
      state.isDraftPreviewOpen = false;
    },
    setApp(state, action: PayloadAction<Partial<AppState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { openDraftPreview, closeDraftPreview, setApp } = appSlice.actions;

export const selectAppState = (state: RootState) => state.app;

export default appSlice.reducer;
